export default (
  { southpoleBaseApi, southpoleRefreshToken },
  store,
  toast,
) => ({
  selectedCurrency(currency) {
    return [
      'EUR',
      'USD',
      'GBP',
      'PLN',
      'CHF',
      'SGD',
      'CAD',
      'CNY',
      'SEK',
      'AUD',
      'TWD',
      'NZD',
      'BRL',
      'JPY',
    ].includes(currency)
      ? currency
      : 'SGD'
  },

  async listOffsetProjects(
    limit = '20',
    currency = '',
    nextPageToken = '',
    attempts = 1,
  ) {
    currency = this.selectedCurrency(currency)
    const accessToken = await this.getAccessToken()
    const url = new URL(`${southpoleBaseApi}compensations/v1/projects`)

    url.searchParams.set('pageSize', limit.toString())
    url.searchParams.set('currency', currency)
    if (nextPageToken) {
      url.searchParams.set('nextPageToken', nextPageToken)
    }

    const response = await fetch(url.href, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })

    return await this.handleResponse(
      response,
      'listOffsetProjects',
      [limit, currency, nextPageToken],
      attempts,
    )
  },

  async projectDetails(id, currency = '', attempts = 1) {
    currency = this.selectedCurrency(currency)
    const accessToken = await this.getAccessToken()
    const response = await fetch(
      `${southpoleBaseApi}compensations/v1/projects/${id}?currency=${currency}`,
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      },
    )

    return await this.handleResponse(
      response,
      'projectDetails',
      [id, currency],
      attempts,
    )
  },

  async checkoutProject(data, attempts = 1) {
    const accessToken = await this.getAccessToken()
    const response = await fetch(
      `${southpoleBaseApi}compensations/v1/checkouts`,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
    )

    return await this.handleResponse(
      response,
      'checkoutProject',
      data,
      attempts,
    )
  },

  async token() {
    const response = await fetch(`${southpoleBaseApi}auth/v1/token`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refreshToken: southpoleRefreshToken }),
    })
    const { accessToken } = await response.json()
    store.southpole.setAccessToken(accessToken)
    return accessToken
  },

  async getAccessToken() {
    return store.southpole.accessToken ?? (await this.token())
  },

  async handleResponse(
    response,
    requestName,
    args,
    attempts,
  ) {
    if (attempts > 2) {
      toast.error(
        'Southpole cannot process your request at this moment. Please try again later!',
        {
          duration: 5000,
          position: 'top-right',
        },
      )
      return
    }
    if (response.status === 401) {
      await this.token()

      const nextAttemptCount = attempts++

      return !Array.isArray(args)
        ? this.checkoutProject(args, nextAttemptCount)
        : await this[requestName](args.toString(), nextAttemptCount)
    }
    else if (response.status === 429) {
      throw new Error('Rate Limit Exceeded')
    }
    else if (response.status === 500) {
      throw new Error(
        'Southpole has encountered an issue, please try again later!',
      )
    }
    else if (!response.ok) {
      throw await response.json()
    }

    return await response.json()
  },
})
